import {
    INSERT_ROLL_EVENT,
    INSERT_EVENT,
    DELETE_EVENT,
    DELETE_COMPOUND_EVENT,
    EDIT_RESOLUTION,
    EDIT_PATTERN,
    MOVE_ROLL_EVENT,
    PASTE_SELECTION,
    DELETE_SELECTION,
    DUPLICATE_SELECTION,
    MOVE_PIANO_ROLL_PATTERN,
    SPLIT_PIANO_ROLL_PATTERN,
    PASTE_PIANO_ROLL_PATTERN,
    DUPLICATE_PIANO_ROLL_PATTERN,
    RESIZE_PIANO_ROLL_PATTERN
} from './constants.js';

export const insertEvent = (event, duration) => ({
    type: INSERT_EVENT,
    payload: {
        event,
        duration
    }
});

export const insertRollEvent = (event, duration) => ({
    type: INSERT_ROLL_EVENT,
    payload: {
        event,
        duration
    }
});

export const deleteEvent = (event, inPlace=false) => ({
    type: DELETE_EVENT,
    payload: {
        event,
        inPlace,
    }
});

export const deleteCompoundEvent = (event, subEvent) => ({
    type: DELETE_COMPOUND_EVENT,
    payload: {
        event,
        subEvent
    }
});

export const editResolution = (event, resolution) => ({
    type: EDIT_RESOLUTION,
    payload: {
        event,
        resolution
    }
});

export const editPattern = (event, pattern) => ({
    type: EDIT_PATTERN,
    payload: {
        event,
        pattern
    }
});

export const moveRollEvent = (event, newStep) => ({
    type: MOVE_ROLL_EVENT,
    payload: {
        event,
        newStep
    }
});

export const pasteSelection = (step, selection, eventType, track) => ({
    type: PASTE_SELECTION,
    payload: {
        step,
        selection,
        eventType,
        track
    }
});

export const deleteSelection = (selection) => ({
    type: DELETE_SELECTION,
    payload: {
        selection
    }
});

export const duplicateSelection = (selection, eventType) => ({
    type: DUPLICATE_SELECTION,
    payload: {
        selection,
        eventType
    }
});

export const movePianoRollPattern = (track, pattern, startStep) => ({
    type: MOVE_PIANO_ROLL_PATTERN,
    payload: {
        track,
        pattern,
        startStep
    }
});


export const splitPianoRollPattern = (track, pattern, step) => ({
    type: SPLIT_PIANO_ROLL_PATTERN,
    payload: {
        track,
        pattern,
        step
    }
});

export const pastePianoRollPattern = (track, pattern, step) => ({
    type: PASTE_PIANO_ROLL_PATTERN,
    payload: {
        track,
        pattern,
        step
    }
});

export const duplicatePianoRollPattern = (track, pattern) => ({
    type: DUPLICATE_PIANO_ROLL_PATTERN,
    payload: {
        track,
        pattern,
    }
});

export const resizePianoRollPattern = (pattern, direction, resizedStep) => ({
    type: RESIZE_PIANO_ROLL_PATTERN,
    payload: {
        pattern,
        direction,
        resizedStep
    }
});







